export enum DocumentElementType {
  MULTI_SELECT = 'CHECKBOX_GROUP',
  SINGLE_SELECT = 'RADIO_GROUP',
  SINGLE_CHECKBOX = 'CHECKBOX',
  TEXT = 'RICH_TEXT_WITH_PLACEHOLDERS',
  TEXT_FIELD = 'TEXT_FIELD',
  DATE = 'DATE_PICKER',
  DATE_TIME = 'DATE_TIME_PICKER',
  PAGE_BREAK = 'PAGE_BREAK',
  SIGNATURE = 'SIGNATURE_BOX',
}

export enum InternalDisplayPreference {
  AS_WRITTEN = 'AS_WRITTEN',
  SUMMARIZED = 'SUMMARIZED',
  DO_NOT_DISPLAY = 'DO_NOT_DISPLAY',
}

export type InputOption = {
  id: string
  inputAction?: string
  internalDisplayPreference?: InternalDisplayPreference
  internalName?: string
  name: string
  sequenceNumber: number
}

type BaseDocumentElement = {
  id: string
  sequenceNumber: number
  type: DocumentElementType
}

export type MultiSelectDocumentElement = BaseDocumentElement & {
  label: string
  options: InputOption[]
  selectedOptionIds: string[] | null
  type: DocumentElementType.MULTI_SELECT
}

export type SingleSelectDocumentElement = BaseDocumentElement & {
  label: string
  options: InputOption[]
  selectedOptionId: string | null
  type: DocumentElementType.SINGLE_SELECT
}

export type SingleCheckboxDocumentElement = BaseDocumentElement & {
  label?: string
  option: InputOption
  selected: boolean
  type: DocumentElementType.SINGLE_CHECKBOX
}

export type TextDocumentElement = BaseDocumentElement & {
  label: string
  type: DocumentElementType.TEXT_FIELD
  value: string
}

export type DateDocumentElement = BaseDocumentElement & {
  date: string
  label: string
  type: DocumentElementType.DATE
}

export type DateTimeDocumentElement = BaseDocumentElement & {
  dateTime: string
  label: string
  type: DocumentElementType.DATE_TIME
}

export type PageBreakDocumentElement = BaseDocumentElement & {
  type: DocumentElementType.PAGE_BREAK
}

export type RichTextDocumentElement = BaseDocumentElement & {
  content: string
  type: DocumentElementType.TEXT
}

export type SignatureDocumentElement = BaseDocumentElement & {
  label?: string
  signature: string | null // SVG
  signer: string | null
  type: DocumentElementType.SIGNATURE
}

export type DocumentElement =
  | MultiSelectDocumentElement
  | SingleSelectDocumentElement
  | SingleCheckboxDocumentElement
  | TextDocumentElement
  | DateDocumentElement
  | DateTimeDocumentElement
  | PageBreakDocumentElement
  | RichTextDocumentElement
  | SignatureDocumentElement

export type DocumentInstanceInfo = {
  businessId: number
  clientId: number
  deleted: boolean
  documentId: number
  expiryDate: string | null
  id: string
  name: string
  patientId: number
  pdfUrl: string | null
  status: string
}

export type DocumentInstance = DocumentInstanceInfo & {
  documentElements: Array<DocumentElement>
}

// Formatted to display in Kiosk
export type PaginatedDocumentInstance = DocumentInstanceInfo & {
  pages: Array<Array<DocumentElement>>
}

export type SignatureDocumentElementFieldValue = {
  signature: string | null
  signer: string | null
}
